import { api } from '@/lib/axios';
import { CreditCardData, CreditCardHolderInfo } from './payments.service';

export interface ReservationCheckoutData {
  reservation: {
    id: string;
    clientId?: string;
    customerName: string;
    customerEmail?: string;
    customerPhone?: string;
    customerDocument?: string | null;
    startDate: string;
    startDateFormatted: string;
    endDate: string;
    startTime?: string;
    endTime?: string;
    total: number;
    basePrice: number;
    discount: number;
    status: string;
    paymentStatus: string;
    venue: {
      id: string;
      name: string;
      description?: string;
      image?: string;
    };
  };
  isPaid: boolean;
  message?: string;
  pix?: {
    qrCode: string;
    copyPaste: string;
    expirationDate: string;
  };
}

export interface UpdateCustomerDocumentResponse {
  success: boolean;
  message: string;
  document: string;
}

export interface PixPaymentResponse {
  reservation: {
    id: string;
    total: number;
  };
  pix: {
    qrCode: string;
    copyPaste: string;
    expirationDate: string;
  };
}

export interface CreditCardPaymentResponse {
  reservation: {
    id: string;
    total: number;
    paymentStatus: string;
  };
  payment: {
    id: string;
    status: string;
  };
}

export interface PaymentStatusResponse {
  reservationId: string;
  paymentStatus: string;
  status: string;
  total: number;
  asaasStatus?: string;
}

export const venueReservationCheckoutService = {
  async getCheckoutData(reservationId: string): Promise<ReservationCheckoutData> {
    const { data } = await api.get(`/venue-reservations/checkout/${reservationId}`);
    return data;
  },

  async createPixPayment(reservationId: string): Promise<PixPaymentResponse> {
    const { data } = await api.post(`/venue-reservations/checkout/${reservationId}/pix`);
    return data;
  },

  async createCreditCardPayment(
    reservationId: string,
    creditCard: CreditCardData,
    holderInfo: CreditCardHolderInfo,
    installments: number = 1,
  ): Promise<CreditCardPaymentResponse> {
    const { data } = await api.post(`/venue-reservations/checkout/${reservationId}/credit-card`, {
      creditCard,
      holderInfo,
      installments,
    });
    return data;
  },

  async getPaymentStatus(reservationId: string): Promise<PaymentStatusResponse> {
    const { data } = await api.get(`/venue-reservations/checkout/${reservationId}/status`);
    return data;
  },

  async updateCustomerDocument(reservationId: string, document: string): Promise<UpdateCustomerDocumentResponse> {
    const { data } = await api.patch(`/venue-reservations/checkout/${reservationId}/customer-document`, {
      document,
    });
    return data;
  },
};
